export const APP_INIT_DATA_FETCH = 'APP_INIT_DATA_FETCH';
export const APP_INIT_DATA_RECEIVE = 'APP_INIT_DATA_RECEIVE';
export const APP_INIT_DATA_FAIL = 'APP_INIT_DATA_FAIL';

export function fetchInitialData(token) {
    return {
        type: APP_INIT_DATA_FETCH,
        token
    };
}

export function fetchInitialDataSuccess(response) {
    return {
        type: APP_INIT_DATA_RECEIVE,
        response
    };
}

export function fetchInitialDataFail() {
    return {
        type: APP_INIT_DATA_FAIL
    };
}
